import rawAxios from "axios";
import axios, { baseUrl } from "../axios/axios";
import {
  ConsultRfzoCreateRequest,
  ConsultRfzoOrderRequest,
  ConsultRfzoTherapyResponse,
} from "../types/consultRfzo.types";

// ITAM-2614 consult RFZO service — the ENTIRE surface is these two calls
// (create + order). No list, no delete: the scope decision limits the feature
// to the create flow.
//
// createPharmacistRfzoTherapy goes through the shared axios instance: its
// meaningful errors are 400 (duplicate / missing lastTherapyDate — the
// {errorCode, message} contract from 84e8a36a) and 404 (user not found), which
// never trip the global 401/403 -> logout interceptor.
//
// orderRfzoTherapy uses a BARE axios call (baseURL + bearer added manually).
// The pharmacist role on this endpoint was only added in 84e8a36a — routing it
// through the shared instance would turn any authorization REGRESSION (403)
// into a full logout mid-consult (see [[axios-interceptor-global-logout]]).
// With the bare call a 403 simply rejects and is mapped to an error message.

const bearerHeader = (): Record<string, string> => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/** POST /rfzo_therapy/pharmacist_create -> 201 + therapy response (orderable flag). */
export const createPharmacistRfzoTherapy = (
  body: ConsultRfzoCreateRequest,
  signal?: AbortSignal
): Promise<ConsultRfzoTherapyResponse> => {
  return axios
    .post<ConsultRfzoTherapyResponse>("/rfzo_therapy/pharmacist_create", body, {
      signal,
    })
    .then((res) => res.data);
};

/**
 * POST /rfzo_therapy/{id}?saveInUserTherapy=true -> 200 with an EMPTY body (no
 * order id — D7). The backend reads ONLY the nested cnCOrderDeliveryRequest
 * (D11); pickup sends {}. On success the therapy row is deleted, so a retry
 * 404s while the order already sits in the Received column.
 */
export const orderRfzoTherapy = (
  therapyId: number,
  body: ConsultRfzoOrderRequest,
  signal?: AbortSignal
): Promise<void> => {
  return rawAxios
    .post<void>(`${baseUrl}/rfzo_therapy/${therapyId}`, body, {
      params: { saveInUserTherapy: true },
      headers: bearerHeader(),
      signal,
    })
    .then(() => undefined);
};
